import { useState } from "react";
import { ReactSVG } from "react-svg";

import { Tab } from "@headlessui/react";

import DonutChart from "../../components/common/charts/Donut-chart";
import CustomBarChart from "../../components/common/charts/Bar-chart";

const personData = [
  { name: "In-person", value: 40 },
  { name: "Virtual", value: 60 },
];
const scheduledData = [
  { name: "Scheduled", value: 80 },
  { name: "Walk-ins", value: 20 },
];
const prescriptionsData = [
  { name: "Prescriptions Issued", value: 73 },
  { name: "End-of-Service", value: 27 },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const DashboardTabs = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const tabsData = [
    {
      label: "Medication Review",
      content: getTabContent(),
    },
    {
      label: "Minor Ailments",
      content: getTabContent(),
    },
    {
      label: "Cardiovascular Coaching",
      content: getTabContent(),
    },
    {
      label: "Diabetes",
      content: getTabContent(),
    },
    {
      label: "Vaccines",
      content: getTabContent(),
    },
    {
      label: "Smoking Cessation",
      content: getTabContent(),
    },
    {
      label: "Interventions",
      content: getTabContent(),
    },
  ];

  return (
    <div>
      <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
        <Tab.List className="flex p-1 space-x-2">
          {tabsData.map((tab, index) => (
            <Tab
              key={index}
              className={({ selected }) =>
                classNames(
                  "py-2 px-4 text-sm font-medium",
                  selected
                    ? "text-teal-500 border-b-2 border-teal-500"
                    : "text-gray-500 hover:text-teal-500"
                )
              }
            >
              {tab.label}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels>
          {tabsData.map((tab, index) => (
            <Tab.Panel key={index} className="mt-4">
              {tab.content}
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

const getTabContent = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
      {/* <!-- Overview --> */}
      <div className="col-span-4">
        <Overview />
        <div className="bg-gray-20 border border-gray-100 shadow-sm rounded-lg p-4 mt-4">
          <h2 className="text-sm font-semibold text-gray-700 mb-4">Minor Ailments</h2>
          <CustomBarChart />
        </div>
      </div>

      {/* <!-- Minor Ailments --> */}
      <div className="bg-gray-20 border border-gray-100 p-4 rounded-lg shadow-lg max-w-xs flex flex-col items-center">
        <div className="p-4 rounded-lg ">
          <h2 className="text-lg font-semibold mb-4">Visit Type</h2>
        </div>
        <div className="h-[200px] w-[200px]">
          <DonutChart data={personData}></DonutChart>
        </div>
        <div className="h-[200px] w-[200px]">
          <DonutChart data={scheduledData}></DonutChart>
        </div>
        <div className="h-[200px] w-[200px]">
          <DonutChart data={prescriptionsData}></DonutChart>
        </div>
      </div>
    </div>
  );
};

const Overview = () => {
  return (
    <div className="bg-gray-20 border border-gray-100 shadow-sm rounded-lg p-4">
      <h2 className="text-sm font-semibold text-gray-700 mb-4">Overview</h2>
      <div className="flex justify-between text-center">
        <div className="inline-flex gap-2">
          <div>
            <p className="text-3xl font-bold text-gray-900">35</p>
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-700 !text-start">
              Completed Visits
            </p>
            <p className="text-xs flex items-center">
              <span className="text-green-500 flex items-center">
                <ReactSVG
                  src="/icons/Green-up-arrow.svg"
                  className="w-5 inline-flex mr-1"
                  data-tooltip-id="guideline-update"
                />
                12%
              </span>{" "}
              in last 7 days
            </p>
          </div>
        </div>
        <div className="inline-flex gap-2">
          <div>
            <p className="text-3xl font-bold text-gray-900">8</p>
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-700 !text-start">
              Follow ups
            </p>
            <p className="text-xs flex items-center">
              <span className="text-green-500 flex items-center">
                <ReactSVG
                  src="/icons/Green-up-arrow.svg"
                  className="w-5 inline-flex mr-1"
                  data-tooltip-id="guideline-update"
                />
                4%
              </span>{" "}
              in last 7 days
            </p>
          </div>
        </div>
        <div className="inline-flex gap-2">
          <div>
            <p className="text-3xl font-bold text-gray-900">8</p>
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-700 !text-start">
              Cancellations
            </p>
            <p className="text-xs flex items-center">
              <span className="text-red-500 flex items-center">
                <ReactSVG
                  src="/icons/Red-down-arrow.svg"
                  className="w-5 inline-flex mr-1"
                  data-tooltip-id="guideline-update"
                />
                83%
              </span>{" "}
              in last 7 days
            </p>
          </div>
        </div>
        <div className="inline-flex gap-2">
          <div>
            <p className="text-3xl font-bold text-gray-900">27</p>
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-700 !text-start">
              Other
            </p>
            <p className="text-xs flex items-center">
              <span className="text-red-500 flex items-center">
                <ReactSVG
                  src="/icons/Red-down-arrow.svg"
                  className="w-5 inline-flex mr-1"
                  data-tooltip-id="guideline-update"
                />
                10%
              </span>{" "}
              in last 7 days
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const DashboardContent = () => {
  return <DashboardTabs />;
};

export default DashboardContent;
